<template>
  <section>

    <h1 class="title has-text-primary">
      Create Mission
    </h1>

    <div class="note">(*) Signifies fields that are required to complete registration</div>
    <b-field grouped group-multiline>
      <b-field label="Mission Name (*)">
        <b-input v-model="form.name"></b-input>
      </b-field>
    </b-field>

    <b-field grouped group-multiline>
      <b-field label="From Date (*)">
        <b-datepicker v-model="form.fromDate"
                      icon="calendar">
        </b-datepicker>
      </b-field>
      <b-field label="End Date (*)">
        <b-datepicker v-model="form.toDate"
                      icon="calendar">
        </b-datepicker>
      </b-field>
    </b-field>
    <b-field label="Country">
      <b-select v-model="form.country"
        icon="globe-americas"
        placeholder="Select Country" required>
        <option v-for="c in listOfCountries"
          v-bind:key="c">{{c}}
        </option>
      </b-select>
    </b-field>
    <hr />

    <button :disabled="!formFilledCompletely()" class="button is-primary" @click="create">Create Mission</button>

  </section>
</template>

<script>
import ApiUtil from '@/utils/ApiUtil';
import ValidationUtil from '@/utils/ValidationUtil';
import ListOfCountries from '@/utils/ListOfCountries';

export default {
  data() {
    return {
      listOfCountries: ListOfCountries.map((c) => { return c.name; }),
      form: {
        name: null,
        fromDate: null,
        toDate: null,
        country: null,
        localContactsId: [],
        activities: [],
      },
    };
  },
  methods: {
    formFilledCompletely() {
      const requiredFields = ['name', 'fromDate', 'toDate', 'country'];
      return ValidationUtil.areFieldsFilledOut(this.form, requiredFields);
    },
    async create() {
      await ApiUtil.createMission(this.form);
      this.$toast.open('Mission created');
      this.$router.push({ name: 'manage-missions' });
    },
  },
};
</script>
<style>
  @import '../../common/inputFieldStyles.scss';
  h1 {
    font-weight: bold;
    font-size: 120%;
    margin-bottom: 10px;
  }
  .note {
    margin-bottom: 10px;
  }
</style>
